import { takeEvery, put, call, select } from "redux-saga/effects";
import endpoints, { endpointTypes } from "../../service";
import { fetchAPI } from "../../utils/service";
import { getPersistData, parseObject } from "../../utils/utils";
import * as adminActionTypes from "./actionTypes";
import * as adminActionCreators from "./actionCreators";
import * as GlobalAction from "../../globalStore/actions";
import * as PaymentAction from "../ThankYou/actionCreators";
import * as dynamicFormActions from "../DynamicForm/actionCreators";
import { RootState } from "../../rootReducer";

const adminRoute = endpoints[endpointTypes.ADMIN];
const formLayoutRoute = endpoints[endpointTypes.FORMLAYOUT];

export function* fetchUserData(action) {
    const endpoint = adminRoute.endpoints.getUserData();
    try {
        const response = yield call(fetchAPI, endpoint);
        if (response) {
            window["AppInsightTrace"].trackTrace("API status code for fetchUserData: " + response.status);
            const persistData = getPersistData();
            if (action.isFromThankyouPage && response.data) {
                yield put(adminActionCreators.fetchUserInfoSuccess({ value: response.data }));
            }
            /* !action.isFromThankyouPage is used for the scenarios of cancel payment - reviewpage, 
            tapping dashboard page on thanyou screen */
            if (
                (response.data.isAdmin || response.data.isTm) &&
                persistData &&
                // persistData.isAlreadyPaymentInitiated &&
                persistData.contractorId &&
                persistData.customerId
            ) {
                const customerId = encodeURIComponent(persistData.customerId);
                const endpoint = adminRoute.endpoints.getContractorData({ customerId: customerId });
                try {
                    const contractorResponse = yield call(fetchAPI, endpoint);
                    if (contractorResponse) {
                        yield put(
                            adminActionCreators.fetchContractorStatusSuccess({ payload: contractorResponse.data })
                        );
                        if (action && !action.isFromThankyouPage) {
                            yield put(PaymentAction.removeContractorIdFromPersistData());
                        }
                    }
                } catch (e) {
                    window["AppInsightTrace"].trackException(`fetchUserData failure ${e}`);
                }
            }
            if (!action.isFromThankyouPage && response.data) {
                yield put(adminActionCreators.fetchUserInfoSuccess({ value: response.data }));
            }
        }
        yield put(GlobalAction.updateLoading(false));
    } catch (err) {
        //Application insight tracking for Exceptions in fetch call
        window["AppInsightTrace"].trackException(`fetchUserData failure ${err}`);
        if (err && err.response && err.response.status === 403) {
            yield put(GlobalAction.showAccessDeniedError(err));
        } else {
            yield put(GlobalAction.showGlobalError(err));
        }
    }
}

export function* fetchUserInfo() {
    yield takeEvery(adminActionTypes.FETCH_USER_INFO, fetchUserData);
}

export function* fetchSearchData(action) {
    const endpoint = adminRoute.endpoints.getSearchData(action.payload);
    try {
        const response = yield call(fetchAPI, endpoint);
        if (response) {
            window["AppInsightTrace"].trackTrace("API status code for fetchSearchData: " + response.status);
            yield put(
                adminActionCreators.fetchSearchRecordsSuccess({
                    paging: response.data.paging,
                    value: response.data.contractors,
                })
            );
        }
    } catch (err) {
        //Application insight tracking for Exceptions in fetch call
        window["AppInsightTrace"].trackException(`fetchSearchData failure ${err}`);
        yield put(GlobalAction.showGlobalError(err));
    }
}

export function* fetchSearchRecords() {
    yield takeEvery(adminActionTypes.FETCH_SEARCH_RECORDS, fetchSearchData);
}

export function* fetchContractorStatus(action) {
    try {
        action.payload.customerId = encodeURIComponent(action.payload.customerId);
        const endpoint = adminRoute.endpoints.getContractorData(action.payload);
        const response = yield call(fetchAPI, endpoint);
        if (response) {
            window["AppInsightTrace"].trackTrace("API status code for fetchContractorStatus: " + response.status);
            yield put(adminActionCreators.fetchContractorStatusSuccess({ payload: response.data }));
        }
    } catch (err) {
        //Application insight tracking for Exceptions in fetch call
        window["AppInsightTrace"].trackException(`fetchContractorStatus failure ${err}`);
        yield put(GlobalAction.showGlobalError(err));
    }
}

export function* fetchContractorInfo() {
    yield takeEvery(adminActionTypes.FETCH_CONTRACTOR_INFO, fetchContractorStatus);
}

export function* fetchWarrantyData(action) {
    const submittedWarrantEndpoint = adminRoute.endpoints.getSubmittedWarrantyData(action.payload);
    const state: RootState = yield select();
    try {
        const WarrantyDetailsResponse = yield call(fetchAPI, submittedWarrantEndpoint);
        if (WarrantyDetailsResponse && WarrantyDetailsResponse.data) {
            const warrantyID = WarrantyDetailsResponse.data.id;
            const warrantynumber = WarrantyDetailsResponse.data.warrantynumber;
            const forminstanceTypeId = WarrantyDetailsResponse.data.formInstanceId;
            const shoppingCartId = WarrantyDetailsResponse.data.shoppingCartId;
            let contractorObj,
                warrantyData,
                customerID = WarrantyDetailsResponse.data.customerId;
            const { layoutResponse } = state.dynamicFormInfo;
            // eslint-disable-next-line prefer-const
            let { JSONSchema, UISchema, ErrorSchema, forminstanceTypeId: existingInstanceId } = layoutResponse;

            // Storing warranty number to use on Thank You page for Resubmit Warranties
            // sessionStorage.setItem('warrantynumber', warrantynumber);

            //getting the contractor details
            try {
                customerID = encodeURIComponent(customerID);
                const contractorDataEndpoint = adminRoute.endpoints.getContractorData({ customerId: customerID });
                const contractorDataResponse = yield call(fetchAPI, contractorDataEndpoint);
                if (contractorDataResponse && contractorDataResponse.data) {
                    // contractorDataResponse.data.isActive = false;    // to check the functionality for an inactive contractor
                    contractorObj = contractorDataResponse.data;
                    window["AppInsightTrace"].trackTrace(
                        "API status code for fetchContractorStatus in fetchWarrantyData: " +
                            contractorDataResponse.status
                    );
                }
            } catch (err) {
                //Application insight tracking for Exceptions in fetch call
                window["AppInsightTrace"].trackException(`fetchContractorStatus failure in fetchWarrantyData ${err}`);
                yield put(GlobalAction.showGlobalError(err));
            }
            let waiverreceived = false;
            if (!shoppingCartId) {
                // getting the warranty data
                // const savedFormDataEndpoint = formLayoutRoute.endpoints.getSavedFormData(warrantyID);
                const savedFormDataEndpoint = formLayoutRoute.endpoints.getSavedFormDataWithWarrantyNumber(warrantynumber);

                try {
                    const formDataResponse = yield call(fetchAPI, savedFormDataEndpoint);
                    if (formDataResponse && formDataResponse.data) {
                        warrantyData = parseObject(formDataResponse.data.warrantyData);
                        if (formDataResponse.data.waiverReciever) {
                            waiverreceived = true;
                        }
                        window["AppInsightTrace"].trackTrace(
                            "API status code for fetchSavedFormData in fetchWarrantyData: " + formDataResponse.status
                        );
                    }
                } catch (err) {
                    yield put(GlobalAction.showGlobalError(err));
                    action.payload.failureCallback && action.payload.failureCallback(err);
                    window["AppInsightTrace"].trackException(`fetchSavedFormData in fetchWarrantyData: ${err}`);
                }
                //getting the formlayout data
                if (
                    !layoutResponse ||
                    (layoutResponse &&
                        (Object.keys(layoutResponse).length === 0 || existingInstanceId !== forminstanceTypeId))
                ) {
                    const formLayoutEndpoint = formLayoutRoute.endpoints.getFormLayout("Residential Warranty");
                    try {
                        formLayoutEndpoint["contractorId"] = contractorObj.contractorId; // passing contractorId into header, for the api to succeed
                        const formLayoutResponse = yield call(fetchAPI, formLayoutEndpoint);
                        if (formLayoutResponse && formLayoutResponse.data) {
                            JSONSchema = parseObject(formLayoutResponse.data.jsonSchema);
                            UISchema = parseObject(formLayoutResponse.data.uiSchema);
                            ErrorSchema = parseObject(formLayoutResponse.data.errorSchema) || [];
                            window["AppInsightTrace"].trackTrace(
                                "API status code for fetchformLayout in fetchWarrantyData: " + formLayoutResponse.status
                            );
                        }
                    } catch (err) {
                        // Application insight tracking for Exceptions in fetch call
                        window["AppInsightTrace"].trackException(`fetchformLayout in fetchWarrantyData: ${err}`);
                        yield put(GlobalAction.showGlobalError(err));
                    }
                }
            }
            const result = {
                forminstanceTypeId,
                errorSchema: ErrorSchema,
                jsonSchema: JSONSchema,
                uiSchema: UISchema,
                id: warrantyID,
                warrantynumber: warrantynumber,
                contractor: contractorObj,
                warrantyData,
                shoppingCartId,
                waiverreceived,
            };
            window["AppInsightTrace"].trackTrace(
                "fetchWarrantyData API status code: " + WarrantyDetailsResponse.status
            );
            yield put(adminActionCreators.fetchWarrantyDetailsSuccess(result));
            // yield put(dynamicFormActions.getErrorResponseOnNavChange({ id: warrantyID }));
        }
    } catch (err) {
        //Application insight tracking for Exceptions in fetch call
        window["AppInsightTrace"].trackException(`fetchWarrantyData failure ${err}`);
        if (err && err.response && err.response.status === 404) {
            yield put(adminActionCreators.invalidWarrentyIdEntry(err.response));
        } else {
            yield put(GlobalAction.showGlobalError(err));
        }
        yield put(adminActionCreators.updateFormSubmittedStatus(false));
    }
}

export function* fetchWarrantyInfo() {
    yield takeEvery(adminActionTypes.FETCH_WARRANTY_DETAILS, fetchWarrantyData);
}

export function* deleteSubmittedWarranty(action) {
    const endpoint = adminRoute.endpoints.deleteSubmittedWarranty(action.payload);
    // yield put(GlobalAction.updateLoading(true));
    try {
        const response = yield call(fetchAPI, endpoint);
        if (response) {
            window["AppInsightTrace"].trackTrace("API status code for deleteSubmittedWarranty: " + response.status);
            yield put(GlobalAction.showGlobalSuccssMsg("Deletion was Successful"));
            yield put(dynamicFormActions.removeFormLayoutData({ payload: true }));
            yield put(adminActionCreators.updateContractorSelection(undefined));
        }
    } catch (err) {
        const { data: { Message = "Deletion was NOT Successful" } = {} } = err.response || {};
        //Application insight tracking for Exceptions in fetch call
        window["AppInsightTrace"].trackException(`deleteSubmittedWarranty failure ${err}`);
        yield put(GlobalAction.showGlobalError({ Message }));
    }
    // yield put(GlobalAction.updateLoading(false));
}

export function* deleteSubmittedWarrantyAdmin() {
    yield takeEvery(adminActionTypes.DELETE_SUBMITTED_WARRANTY, deleteSubmittedWarranty);
}

export function* deleteSubmittedShoppingCart(action) {
    const { cartId, successCallBack } = action.payload || {};
    const endpoint = adminRoute.endpoints.deleteSubmittedShoppingCart(cartId);
    // yield put(GlobalAction.updateLoading(true));
    try {
        const response = yield call(fetchAPI, endpoint);
        if (response) {
            window["AppInsightTrace"].trackTrace("API status code for deleteSubmittedWarranty: " + response.status);
            yield put(GlobalAction.showGlobalSuccssMsg("Deletion was Successful"));
            yield put(dynamicFormActions.removeFormLayoutData({ payload: true }));
            yield put(adminActionCreators.updateContractorSelection(undefined));
            successCallBack && successCallBack();
        }
    } catch (err) {
        const { data: { Message = "Deletion was NOT Successful" } = {} } = err.response || {};
        //Application insight tracking for Exceptions in fetch call
        window["AppInsightTrace"].trackException(`deleteSubmittedWarranty failure ${err}`);
        yield put(GlobalAction.showGlobalError({ Message }));
    }
    // yield put(GlobalAction.updateLoading(false));
}

export function* deleteSubmittedShoppingCartAdmin() {
    yield takeEvery(adminActionTypes.DELETE_SUBMITTED_SHOPPING_CART, deleteSubmittedShoppingCart);
}